import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const createPageUrl = (path) => {
  // In a real app, this might prepend a base URL or handle routing differently.
  return path;
};
